import { ACCESS_KEY, urlAPI } from "../../../urls"

export async function strapiSendNotify (customBody: Record<string, unknown>): Promise<any> {
    const jwt = window.localStorage.getItem(ACCESS_KEY) as string
    try {

        const sentBodyForNotification = {
            method: 'POST',
            collection: 'user-notifies',
            body: {
                mode: 'publish',
                // executeAt: notificationTime,
                // RuleID: ObjectID,
                // Rule: rule,
                // User: userID,
                // Text: text,
                Type: 'Mobile',
                publishedAt: null,
                ...{customBody}
            }
        }


        const requestForNotification = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(sentBodyForNotification),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const requestForNotificationJSON = await requestForNotification.json()

        return requestForNotificationJSON
    } catch (error) {
        console.log(error)
    }
}